// extracted by mini-css-extract-plugin
module.exports = {"container":"medicalSation_container__Yz3Fw","containerP":"medicalSation_containerP__3V2BG"};